import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { FilterSections } from '../constants/filter/filter_sections';
import { FilterActions } from '../constants/filter/filter_actions';

class CatalogFilterViewStoreClass extends ReduceStore {
  getInitialState() {
    const sectionVisibility = {};
    sectionVisibility[FilterSections.TYRE_INDEX_VIEW] = false;
    sectionVisibility[FilterSections.BRAND_VIEW] = false;
    sectionVisibility[FilterSections.PRICE_VIEW] = false;
    sectionVisibility[FilterSections.DEALS_VIEW] = false;
    sectionVisibility[FilterSections.FEATURES_VIEW] = false;
    sectionVisibility[FilterSections.ADDITIONAL_VIEW] = false;
    sectionVisibility[FilterSections.WHEEL_BRAND_VIEW] = false;
    sectionVisibility[FilterSections.WHEEL_SIZE_VIEW] = false;
    sectionVisibility[FilterSections.WHEEL_BOLT_PATTERN_VIEW] = false;
    sectionVisibility[FilterSections.USAGE_VIEW] = false;
    sectionVisibility[FilterSections.FITMENT_VIEW] = false;
    sectionVisibility[FilterSections.TECHNOLOGY_VIEW] = false;
    sectionVisibility[FilterSections.TYRE_RATINGS_VIEW] = false;
    sectionVisibility[FilterSections.CUSTOMER_REVIEWS_VIEW] = false;
    sectionVisibility[FilterSections.QUALITY_SEGMENT_VIEW] = false;
    sectionVisibility[FilterSections.SEASON_VIEW] = false;
    sectionVisibility[FilterSections.EV_VIEW] = false;

    return {
      sectionVisibility,
      visible: false,
    };
  }

  reduce(state, { source, action }) {
    if (source === ACTION_TYPES.CATALOG_FILTER_VIEW_ACTION) {
      switch (action.type) {
        case FilterActions.SHOW_FILTER:
          if (!state.visible) {
            state.visible = true;
            this.__emitChange();
          }

          break;
        case FilterActions.HIDE_FILTER:
          if (state.visible) {
            state.visible = false;
            this.__emitChange();
          }

          break;
        case FilterActions.SHOW_FILTER_SECTION:
          if (
            typeof state.sectionVisibility[action.payload] !== 'undefined' &&
            !state.sectionVisibility[action.payload]
          ) {
            state.sectionVisibility[action.payload] = true;
            this.__emitChange();
          }

          break;
        case FilterActions.HIDE_FILTER_SECTION:
          if (
            typeof state.sectionVisibility[action.payload] !== 'undefined' &&
            state.sectionVisibility[action.payload]
          ) {
            state.sectionVisibility[action.payload] = false;
            this.__emitChange();
          }

          break;
      }
    }

    return state;
  }
}

const CatalogFilterViewStore = new CatalogFilterViewStoreClass(Dispatcher);
export default CatalogFilterViewStore;
